export default __webpack_public_path__ + "static/media/1.ffc5a52c.png";